import { paths } from "types/declarations/api";

type Endpoint = paths["/api/v1/orders/updates"]["get"];
type Success = Endpoint["responses"]["200"];
/** Shape documented in swagger: `{ data: [...] }` */
export type GetOrderUpdatesWrappedResponse = Success["content"]["application/json"];

export type GetOrderUpdatesResponseData = NonNullable<GetOrderUpdatesWrappedResponse["data"]>;
export type OrderUpdate = GetOrderUpdatesResponseData[number];

/** The endpoint currently returns a bare array, swagger documents the `{ data }` wrapper; support both. */
export type GetOrderUpdatesResponse = GetOrderUpdatesResponseData | GetOrderUpdatesWrappedResponse;

export const ORDER_DETAILS_ROUTE = "/details";

export const normalizeOrderUpdatesResponse = (
	response: GetOrderUpdatesResponse | null | undefined
): GetOrderUpdatesResponseData => {
	if (Array.isArray(response)) return response;

	return response?.data ?? [];
};

const trimTrailingSlash = (value: string) => value.replace(/\/$/, "");

/**
 * Last path segment of the details url, e.g.
 * `https://test.orders.cabinetworksgroup.com/details/Decade-3644047` → `Decade-3644047`.
 * Does not use `orderNumber`.
 */
export const getOrderUpdateOrderId = ({ url }: Pick<OrderUpdate, "url">) => {
	const value = url?.trim();
	if (!value) return undefined;

	try {
		const pathname = trimTrailingSlash(new URL(value, globalThis.location.origin).pathname);
		const prefix = `${ORDER_DETAILS_ROUTE}/`;
		if (!pathname.startsWith(prefix)) return undefined;

		const lastPart = decodeURIComponent(pathname.slice(prefix.length));
		return !lastPart || lastPart.includes("/") ? undefined : lastPart;
	} catch {
		return undefined;
	}
};
